import { render, staticRenderFns } from "./AdquirirSaldoCtaCte.vue?vue&type=template&id=2f5a4b39&scoped=true&"
import script from "./AdquirirSaldoCtaCte.vue?vue&type=script&lang=js&"
export * from "./AdquirirSaldoCtaCte.vue?vue&type=script&lang=js&"
import style0 from "./AdquirirSaldoCtaCte.vue?vue&type=style&index=0&id=2f5a4b39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a4b39",
  null
  
)

export default component.exports